import React from 'react';
import { CheckCircle, Circle, Clock, AlertTriangle } from 'lucide-react';

const TaskStats = ({ tasks }) => {
  const totalTasks = tasks.length;
  const completedTasks = tasks.filter(task => task.completed).length;
  const activeTasks = totalTasks - completedTasks;
  const overdueTasks = tasks.filter(task => 
    !task.completed && 
    task.due_date && 
    new Date(task.due_date) < new Date()
  ).length;
  
  const completionRate = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;

  const stats = [
    {
      label: 'Total Tasks',
      value: totalTasks,
      icon: Circle,
      color: 'var(--bamboo-sage)',
      bgColor: 'rgba(156, 175, 136, 0.1)'
    },
    {
      label: 'Active',
      value: activeTasks,
      icon: Clock,
      color: 'var(--bamboo-green)',
      bgColor: 'var(--shadow-light)'
    },
    {
      label: 'Completed',
      value: completedTasks,
      icon: CheckCircle,
      color: '#48bb78',
      bgColor: 'rgba(72, 187, 120, 0.1)'
    },
    {
      label: 'Overdue',
      value: overdueTasks,
      icon: AlertTriangle,
      color: '#e53e3e',
      bgColor: 'rgba(229, 62, 62, 0.1)'
    }
  ];

  return (
    <div className="task-stats card">
      <h3>Task Overview</h3>
      
      <div className="completion-rate">
        <div className="completion-circle">
          <svg viewBox="0 0 36 36" className="circular-chart">
            <path
              className="circle-bg"
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="circle"
              strokeDasharray={`${completionRate}, 100`}
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
          </svg>
          <div className="percentage">{completionRate}%</div>
        </div>
        <p>Completion Rate</p>
      </div>

      <div className="stats-grid">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="stat-item">
              <div 
                className="stat-icon"
                style={{ 
                  color: stat.color,
                  backgroundColor: stat.bgColor 
                }}
              >
                <Icon size={16} />
              </div>
              <div className="stat-content">
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TaskStats;
